import { put, call, takeEvery } from 'redux-saga/effects';
import { replace } from 'connected-react-router';
import {
  FEEDS_REQUEST,
  FEED_REQUEST,
  CREATE_FEED_REQUEST,
  UPDATE_FEED_REQUEST,
  DELETE_FEED_REQUEST,
} from './actionTypes';
import {
  feedsSuccess,
  feedsFailure,
  feedSuccess,
  feedFailure,
  createFeedSuccess,
  createFeedFailure,
  updateFeedSuccess,
  updateFeedFailure,
  deleteFeedSuccess,
  deleteFeedFailure,
} from './actions';
import FeedService from '../../services/FeedService';

export function* getFeedsTask() {
  try {
    const list = yield call(FeedService.getFeeds);
    yield put(feedsSuccess(list));
  } catch (error) {
    yield put(feedsFailure(error));
  }
}

export function* getFeedTask(action) {
  try {
    const feedId = action.payload;
    const feed = yield call(FeedService.getFeed, feedId);
    yield put(replace(`/feed/${feedId}`));
    yield put(feedSuccess(feed));
  } catch (error) {
    yield put(feedFailure(error));
  }
}

export function* createFeedTask(action) {
  try {
    const params = action.payload;
    const feed = yield call(FeedService.createFeed, params);
    yield put(createFeedSuccess(feed));
    yield put(replace('/feeds'));
  } catch (error) {
    yield put(createFeedFailure(error));
  }
}

export function* updateFeedTask(action) {
  try {
    const feed = action.payload;
    const updatedFeed = yield call(FeedService.updateFeed, feed);
    yield put(updateFeedSuccess(updatedFeed));
    yield put(replace('/feeds'));
  } catch (error) {
    yield put(updateFeedFailure(error));
  }
}

export function* deleteFeedTask(action) {
  try {
    const feedId = action.payload;
    yield call(FeedService.deleteFeed, feedId);
    yield put(deleteFeedSuccess(feedId));
  } catch (error) {
    yield put(deleteFeedFailure(error));
  }
}

export function* feedsSaga() {
  yield takeEvery(FEEDS_REQUEST, getFeedsTask);
  yield takeEvery(FEED_REQUEST, getFeedTask);
  yield takeEvery(CREATE_FEED_REQUEST, createFeedTask);
  yield takeEvery(UPDATE_FEED_REQUEST, updateFeedTask);
  yield takeEvery(DELETE_FEED_REQUEST, deleteFeedTask);
}
